var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "task-config-container" }, [
    _c(
      "div",
      { staticClass: "list-container" },
      [
        _c(
          "el-form",
          {
            staticClass: "compact-search-form",
            attrs: { inline: true, model: _vm.searchForm },
          },
          [
            _c(
              "el-form-item",
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "220px" },
                    attrs: {
                      placeholder: "选择活动",
                      clearable: "",
                      filterable: "",
                    },
                    model: {
                      value: _vm.searchForm.activityId,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "activityId", $$v)
                      },
                      expression: "searchForm.activityId",
                    },
                  },
                  _vm._l(_vm.actList, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: {
                        label: item.activityName,
                        value: String(item.id),
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  staticStyle: { width: "220px" },
                  attrs: { placeholder: "手机号/昵称", clearable: "" },
                  model: {
                    value: _vm.searchForm.keywords,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "keywords", $$v)
                    },
                    expression: "searchForm.keywords",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              [
                _c("el-date-picker", {
                  attrs: {
                    type: "datetimerange",
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                    "value-format": "yyyy-MM-dd HH:mm:ss",
                  },
                  on: { change: _vm.changeTime },
                  model: {
                    value: _vm.times,
                    callback: function ($$v) {
                      _vm.times = $$v
                    },
                    expression: "times",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { staticClass: "form-actions" },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.fetchList } },
                  [_vm._v("查询")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.exportData } },
                  [_vm._v("导出")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: { data: _vm.tableData, stripe: "", border: "" },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "id", label: "ID", align: "center", width: "80" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "activityName",
                label: "活动名称",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "mobile",
                label: "手机号",
                align: "center",
                width: "130",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "nickname", label: "昵称", align: "center" },
            }),
            _vm._v(" "),
            _vm.isReward
              ? _c("el-table-column", {
                  attrs: { prop: "rewardDesc", label: "奖励", align: "center" },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isReward
              ? _c("el-table-column", {
                  attrs: { prop: "couponNo", label: "券号", align: "center" },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isReward
              ? _c("el-table-column", {
                  attrs: { label: "发放状态", align: "center", width: "100" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.couponLogStatus === 1
                              ? _c("el-tag", { attrs: { type: "info" } }, [
                                  _vm._v("等待"),
                                ])
                              : scope.row.couponLogStatus === 2
                              ? _c("el-tag", { attrs: { type: "danger" } }, [
                                  _vm._v("异常"),
                                ])
                              : scope.row.couponLogStatus === 3
                              ? _c("el-tag", { attrs: { type: "success" } }, [
                                  _vm._v("成功"),
                                ])
                              : _c("span", [_vm._v("-")]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    806777381
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "发布时间", align: "center", width: "170" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(_vm._s(_vm.formatDate(scope.row.publishTime))),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _vm.isReward
              ? _c("el-table-column", {
                  attrs: { label: "领奖时间", align: "center", width: "170" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.formatDate(scope.row.receiveTime))
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3013456117
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "帖子链接",
                align: "center",
                width: "180",
                fixed: "right",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.postUrl
                        ? [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.copyPostUrl(scope.row)
                                  },
                                },
                              },
                              [_vm._v("复制")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openPostUrl(scope.row)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            ),
                          ]
                        : _c("span", [_vm._v("-")]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
                "current-page": _vm.searchForm.page,
                "page-sizes": [10, 20, 30, 50],
                "page-size": _vm.searchForm.limit,
                total: _vm.searchForm.total,
              },
              on: {
                "current-change": _vm.handlePageChange,
                "size-change": _vm.handleSizeChange,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }